import React from 'react';
import { IconProps } from '.';

const SvgBoxes = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M22.25 11.25v11H1.75v-11H6.5v-9.5h11v9.5h4.75Zm-8.25-8h2v8H8v-8h2v4.5h4v-4.5Zm.75 9.5h-2v8h8v-8h-2v4.5h-4v-4.5Zm2.5 0h-1v3h1v-3Zm-6 0v8h-8v-8h2v4.5h4v-4.5h2Zm-3.5 0h-1v3h1v-3Zm4.75-9.5h-1v3h1v-3Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgBoxes;
